/**
 * @generated SignedSource<<d80fa709c296ecee5ebfae3076e1a8a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ApiSalesChannelInput = {
  currencyID?: string | null;
  id?: string | null;
  productApiUrl?: string | null;
  storeUrl?: string | null;
};
export type apiIntegrationSalesChannelDialogInsertMutation$variables = {
  input: ApiSalesChannelInput;
};
export type apiIntegrationSalesChannelDialogInsertMutation$data = {
  readonly upsertApiSalesChannel: {
    readonly clientID: number;
    readonly id: string;
    readonly salesChannelID: number;
    readonly secretKey: string | null;
  };
};
export type apiIntegrationSalesChannelDialogInsertMutation = {
  response: apiIntegrationSalesChannelDialogInsertMutation$data;
  variables: apiIntegrationSalesChannelDialogInsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ApiKey",
    "kind": "LinkedField",
    "name": "upsertApiSalesChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secretKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesChannelID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiIntegrationSalesChannelDialogInsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiIntegrationSalesChannelDialogInsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25e0f951041fd48c24a9f10af2f63919",
    "id": null,
    "metadata": {},
    "name": "apiIntegrationSalesChannelDialogInsertMutation",
    "operationKind": "mutation",
    "text": "mutation apiIntegrationSalesChannelDialogInsertMutation(\n  $input: ApiSalesChannelInput!\n) {\n  upsertApiSalesChannel(input: $input) {\n    id\n    clientID\n    secretKey\n    salesChannelID\n  }\n}\n"
  }
};
})();

(node as any).hash = "f346da4c92f4169291b406b2373b7672";

export default node;
